<template>
  <div class="car-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.rentSlstatus"
            placeholder="租赁状态"
            style="width: 160px; display: inline-block; margin-left: 10px"
            @change="onChangeStripe()"
          >
            <el-option
              v-for="item in rentSlstatus"
              :key="item.car_status"
              :label="item.name"
              :value="item.car_status"
            ></el-option>
          </el-select>
          <el-input
            v-model="form.value"
            placeholder="请输入车架号"
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            v-hasPermi="['车辆管理', '新增']"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('/car/add')"
            >增加车辆</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <template>
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="frame_num"
            label="车架号"
            show-overflow-tooltip
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tbox_num"
            label="TBOX编号"
            show-overflow-tooltip
            width="300"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="work_num"
            label="车工号"
            show-overflow-tooltip
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="brand"
            label="车辆品牌"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="车辆型号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="maintenance_time"
            label="维护时间"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="model"
            label="车型"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="belong_department"
            label="归属部门"
            align="center"
          ></el-table-column>
          <el-table-column prop="online" label="在线/离线" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.online == 1" class="status green"
                >在线</span
              >
              <span class="status" v-else>离线</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="car_status"
            label="租赁状态"
            width="80"
            align="center"
          >
            <template slot-scope="{ row }">
              <span class="status" v-show="row.car_status == 1">已出租</span>
              <span class="status" v-show="row.car_status == 0">未出租</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="300"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="edit">
                <span
                  class="btn read"
                  v-hasPermi="['车辆管理', '租赁']"
                  v-if="scope.row.car_status == 0"
                  @click="
                    rentalClick(
                      scope.row.id,
                      0,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  >租赁</span
                >
                <span
                  class="btn read"
                  v-hasPermi="['车辆管理', '收回']"
                  v-if="scope.row.car_status == 1"
                  @click="
                    rentalClick(
                      scope.row.id,
                      1,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  >收回</span
                >
                <span
                  class="btn read"
                  v-hasPermi="['车辆管理', '详情']"
                  @click="
                    readClick(
                      scope.row.id,
                      scope.row.frame_num,
                      scope.row.rent_company,
                      scope.row.tbox_num
                    )
                  "
                  >查看</span
                >
                <span
                  class="btn read"
                  v-hasPermi="['车辆管理', '定位']"
                  @click="positioning(scope.row.frame_num)"
                  >定位</span
                >
                <span
                  class="btn read"
                  @click="deleteClick(scope.row.id)"
                  v-hasPermi="['车辆管理', '删除']"
                  >注销</span
                >
                <span
                  class="btn read"
                  @click="openDialog(scope.row)"
                  v-hasPermi="['车辆管理', '移交']"
                  >移交</span
                >
                <span
                  class="btn read"
                  @click="
                    continueClick(
                      scope.row.id,
                      1,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  >续费</span
                >
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <!-- <edit v-if="dialogVisible" @refresh="getData"/> -->
    <rental v-if="dialogVisible" />
    <continues v-if="continueDialogVisible" />
    <el-dialog
      title="移交车辆"
      :visible.sync="transferDialogVisible"
      width="500px"
    >
      <el-form
        ref="transfer"
        :rules="rules"
        :model="transferInfo"
        label-width="120px"
      >
        <el-form-item label="接受部门" prop="into_depart">
          <el-select
            style="width: 100%"
            v-model="transferInfo.into_depart"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in departList"
              :key="index"
              :label="item.department"
              :value="item.department"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车架号">
          <el-input
            v-model="transferInfo.frame_num"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="转出部门">
          <el-input
            v-model="transferInfo.out_depart"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注信息" prop="remark">
          <el-input v-model="transferInfo.remark"></el-input>
        </el-form-item>
        <el-button type="primary" @click="submitForm('transfer')"
          >确认移交</el-button
        >
        <el-button @click="transferDialogVisible = false">取消</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCarList,
  GetSortList,
  deleteLogicCar,
  getDepartment,
  transfer,
} from '@/api/car';
import { MessageBox } from 'element-ui';
import rental from './rental.vue';
import continues from './continue.vue';
let usrInfo = JSON.parse(localStorage.getItem('user'));
export default {
  components: {
    rental,
    continues,
  },
  data() {
    return {
      RoleId: sessionStorage.RoleId,
      dialogVisible: false,
      continueDialogVisible: false,
      transferDialogVisible: false,
      form: {
        value: '',
        sort: '',
        rentSlstatus: '',
      },
      childform: {
        id: '',
        type: '',
      },
      loading: false,
      options: [{ name: '默认', sort: '' }],
      rentSlstatus: [
        { name: '全部', car_status: '' },
        { name: '已租', car_status: '1' },
        { name: '未租', car_status: '0' },
      ],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0,
      },
      departList: [],
      transferInfo: {
        car_id: '',
        into_depart: '',
        frame_num: '',
        out_depart: '',
        remark: '',
      },
      rules: {
        into_depart: [{ required: true, message: '请选择', trigger: 'change' }],
        remark: [{ required: true, message: '请输入', trigger: 'change' }],
      },
    };
  },
  created() {
    this.getSortData();
    this.getData();
    this.getDepartment();
  },
  mounted() {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          transfer(this.transferInfo).then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message.success('移交成功!');
              this.transferDialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    getDepartment() {
      if (usrInfo.belongCompany && usrInfo.belongCompany !== 'null') {
        getDepartment({ companyId: usrInfo.belongCompany }).then((da) => {
          this.departList = da.data;
        });
      }
    },
    openDialog(val) {
      this.transferInfo.car_id = val.id;
      this.transferInfo.out_depart = val.belong_department;
      this.transferInfo.into_depart = '';
      this.transferInfo.frame_num = val.frame_num;
      this.transferInfo.remark = '';
      this.transferDialogVisible = true;
    },
    //车辆定位
    positioning(num) {
      this.$router.push({ name: 'Home', params: { num } });
    },
    refresh() {
      this.getData();
    },
    onChangeStripe() {
      this.search();
    },
    deleteClick(id) {
      MessageBox.confirm('此操作将注销该车辆的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteLogicCare(id);
        })
        .catch(() => {
          this.$message('已取消注销');
        });
    },
    deleteLogicCare(id) {
      deleteLogicCar({ id }).then((res) => {
        if (res.code === 0) {
          this.$message.success('注销成功!');
          this.refresh();
        } else {
          this.$message.err(res.message);
        }
      });
    },
    getSortData() {
      GetSortList().then((res) => {
        this.options = this.options.concat(res.data);
      });
    },

    //获取列表信息
    getData() {
      this.loading = true;
      const params = { start: this.table.currentPage, size: this.table.size };
      this.form.sort ? (params.sort = this.form.sort) : '';
      params.car_status = this.form.rentSlstatus;
      this.form.value ? (params.frame_num = this.form.value) : '';
      GetCarList(params).then((res) => {
        // console.log(res)
        this.loading = false;
        const data = res.data;
        this.table.data = data.content;
        this.table.total = data.total;
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      });
    },
    search() {
      this.table.currentPage = 1;
      this.getData();
    },
    currentChange() {
      this.getData();
    },
    handleSizeChange(e) {
      this.table.currentPage = 1;
      this.table.size = e;
      this.getData();
    },
    readClick(id, frame_num, rent_company, tbox_num) {
      this.$router.push({
        name: 'CarDetail',
        query: { id, frame_num, rent_company, tbox_num },
      });
    },
    rentalClick(id, type, frame_num, tbox_num) {
      if (type === 1) {
        this.dialogName = '回收';
      } else if (type === 0) {
        this.dialogName = '租赁';
      }
      this.childform.id = id;
      this.childform.type = type;
      this.childform.frame_num = frame_num;
      this.childform.tbox_num = tbox_num;
      this.dialogVisible = true;
    },
    // continueClick(id, type, frame_num, tbox_num) {
    // this.dialogName = "续期";
    // this.childform.id = id;
    // this.childform.type = type;
    // this.childform.frame_num = frame_num;
    // this.childform.tbox_num = tbox_num;
    // this.continueDialogVisible = true;
    continueClick() {
      MessageBox('功能待开发', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          this.$message({
            type: 'info',
            message: `action: ${action}`,
          });
        },
      });
    },
  },
  filters: {
    status_f(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '离线';
          break;
        case 1:
          res = '在线';
          break;
      }
      return res;
    },
  },
};
</script>

<style lang="less" scoped>
.car-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.car-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
.status {
  &.green {
    color: #53c553;
  }
}
</style>
